import styled, { css } from 'styled-components'
import { colors, derivedColors } from '../../../const'

export const ModalTitle = styled.h2`
  color: ${colors.textPrimary};
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0;
  margin-block-start: 0.5em;
  text-align: center;
`

export const ModalDescription = styled.p`
  color:${({ color }) => color || colors.textSecondary};
  line-height: 24px;
  font-size: 1rem;
  text-align: center;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
`

export const ButtonsWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 0rem;
  width: 100%;
`

export const Button = styled.button(
  ({ highlighted }) => css`
    padding: 0.6rem 1.2rem;
    border-radius: 6px;
    border: 1px solid transparent;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    align-items: center;
    background-color: ${highlighted ? (highlighted === 'cancel' ? colors.error : colors.primary) : derivedColors.transparentSecondary};
    border: none;
    
    color: ${highlighted ? colors.surface : colors.primary};
    
    display: flex;
    font-family: 'Inter';
    font-size: 0.875rem;
    font-weight: 500;
    height: 40px;
    justify-content: center;
    margin: 0 2%;
    max-width: 130px;
    width: 100%;
  `
)

export const Input = styled.input`
    background-color: ${colors.surface};
    border: 1px solid ${colors.borderSubtle};
    border-bottom-width: 2px;
    border-radius: 6px;
    font-family: 'Inter';
    padding: 0.75rem;
    position: relative;
    height: 40px;
    width: 100%;
    margin-bottom: 1.5rem;

    &:focus {
      outline: none;
      background-color: ${colors.surface};
      border-bottom-color: ${colors.primary};
    }
  `
